const HandleSearchInputComponent = (
    {
        e, setSearchInput, searchTimeout, setSearchTimeout, performSearch
    }
    ) => {
    const searchText = e.target.value;
    setSearchInput(searchText); // Aggiorna sempre il valore dell'input
    
    // Cancella il timeout precedente se esiste
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    // Se il campo è vuoto, esegui subito la ricerca per mostrare tutti i risultati
    if (searchText.length === 0) {
      performSearch(searchText);
      return;
    }
    
    // Se ha meno di 3 caratteri, non fare nulla
    if (searchText.length < 3) {
      return;
    }
    
    // Se ha 3+ caratteri, imposta un timeout di 2 secondi
    const timeout = setTimeout(() => {
      performSearch(searchText);
    }, 1200);
    
    setSearchTimeout(timeout);
  };

// Funzione per eseguire la ricerca
export const performSearchHandleSearchInputComponent = async ({
    searchText, 
    isWoman,    
    currentPage, 
    year, 
    setWrestlers, 
    setPagination, 
    setError, 
    setIsLoading, 
    apiTotal,
    apiWomanTotal
    }) => {
        console.log('searchText');
    setIsLoading(true);
    try {
      if (searchText.length === 0) {
        // Se il campo è vuoto, mostra tutti i risultati
        const response = isWoman ? await apiWomanTotal(currentPage, year) : await apiTotal(currentPage, year);
        if (response.success) {
          setWrestlers(response.data);
          setPagination(response.pagination);
        } else {
          setError('Failed to load wrestlers');
        }
      } else {
        // Se ha 3+ caratteri, esegui la ricerca con filtro
        const response = isWoman ? await apiWomanTotal(currentPage, year, searchText) : await apiTotal(currentPage, year, searchText);
        if (response.success) {
          setWrestlers(response.data);
          setPagination(response.pagination);
        } else {
          setError('Failed to load wrestlers');
        }
      }
    } catch (err) {
      setError('Error loading wrestlers');
      console.error('Error:', err);
    } finally {
      setIsLoading(false);
    }
  };

export default HandleSearchInputComponent;